import { render, staticRenderFns } from "./pricingarea.vue?vue&type=template&id=0ea1a154&scoped=true"
import script from "./pricingarea.vue?vue&type=script&lang=js"
export * from "./pricingarea.vue?vue&type=script&lang=js"
import style0 from "./pricingarea.vue?vue&type=style&index=0&id=0ea1a154&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea1a154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea1a154')) {
      api.createRecord('0ea1a154', component.options)
    } else {
      api.reload('0ea1a154', component.options)
    }
    module.hot.accept("./pricingarea.vue?vue&type=template&id=0ea1a154&scoped=true", function () {
      api.rerender('0ea1a154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commodityreference/pricingmanagement/pricingarea.vue"
export default component.exports